export const variantAlphabet = (offset: number, prefix?: string) => {
  const alphabet = String.fromCharCode('A'.charCodeAt(0) + offset);
  return prefix ? `${prefix} ${alphabet}` : alphabet;
};
